// extracted by mini-css-extract-plugin
export default {"container":"TP-z","dimension":"UP-z","dimensionLabels":"VP-z"};